import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';

import { UPDATE_USER_INTERVIEWS_TESTER_PAY_STATUS } from './graphql';
import {
  Dropdown,
} from './styles';

const PayDropdown = (props) => {
  const {
    testerId,
    userInterviewsPayStatus,
    userInterviewsStatus,
    refetchParticipants,
  } = props;

  const [status, setStatus] = useState(userInterviewsPayStatus);

  const [updateUserInterviewsTesterPayStatus] = useMutation(UPDATE_USER_INTERVIEWS_TESTER_PAY_STATUS);

  const handleChange = async (e, { value }) => {
    const response = await updateUserInterviewsTesterPayStatus({ variables: { testerId, status: value } });

    if (response?.data?.updateUserInterviewsTesterPayStatus?.tester?.userInterviewsPayStatus) {
      setStatus(value);
      refetchParticipants();
    }
  };

  return (
    <Dropdown
      onChange={handleChange}
      selection
      disabled={userInterviewsStatus === 'no_show' || userInterviewsStatus === 'complete'}
      options={[
        { key: 1, text: 'Pay', value: 'pay' },
        { key: 2, text: 'Do Not Pay', value: 'do_not_pay' },
      ]}
      value={status}
    />
  );
};

PayDropdown.propTypes = {
  testerId: PropTypes.string.isRequired,
  userInterviewsPayStatus: PropTypes.bool.isRequired,
  userInterviewsStatus: PropTypes.bool.isRequired,
  refetchParticipants: PropTypes.func.isRequired,
};

export default PayDropdown;
